import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBadDebts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/bad_debts/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchBadDebt(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/bad_debts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editBadDebt(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/bad_debts", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteBadDebt(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/bad_debts", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
